import React, { useState, useEffect, useContext } from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import envConfig from '@nile/home/src/Config/env';
import { AppContext } from '@nile/components';
import Auth from '@nile/home/src/Auth/Auth';

function PublicRoute(props) {
  const { component: Component, layout: Layout, ...rest } = props;

  const { accountType } = useContext(AppContext);

  const [previousLocation, setPreviousLocation] = useState('');

  useEffect(() => {
    setPreviousLocation(props.location.pathname);
  }, []);

  useEffect(() => {
    if (previousLocation !== props?.location?.pathname) {
      setPreviousLocation(props.location.pathname);
      if (envConfig.mode !== 'development') {
        // Intercom update
        window.Intercom('update');
      }
    }
  }, [props.location?.pathname]);

  const getPathName = () => {
    const redirectUrl = sessionStorage.getItem('redirectUrl');
    let pathName = redirectUrl
      ? redirectUrl
      : accountType === 'CLIENT'
      ? '/client-home'
      : '/home';

    const initialParams = sessionStorage.getItem('redirectUrlParams');
    if (initialParams) {
      const params = new URLSearchParams(initialParams);
      const appStateParam = params.get('appState');
      if (appStateParam) {
        const appState = JSON.parse(decodeURIComponent(appStateParam));
        const targetRoute = appState?.targetRoute;
        if (targetRoute && targetRoute === 'agentMarketplace') {
          pathName = '/agent/marketplace';
        }
      }
    }

    return pathName;
  };

  const getUrlParams = () => {
    const redirectUrlParams = sessionStorage.getItem('redirectUrlParams');
    return redirectUrlParams;
  };

  const getURLParamsAndPathName = () => {
    const pathName = getPathName();
    const urlParams = getUrlParams();
    return { pathName, urlParams };
  };

  const { pathName, urlParams } = getURLParamsAndPathName();

  return (
    <Route
      {...rest}
      render={(props) =>
        Auth.isAuthenticated ? (
          <Redirect
            to={{
              pathname: pathName,
              search: urlParams,
              state: { from: props.location }
            }}
          />
        ) : (
          <Layout routeComponent={<Component {...props} />}></Layout>
        )
      }
    />
  );
}
export default withRouter(PublicRoute);
